import { Modal } from "react-bootstrap";
import { qreq } from "../shared/qrequest";
import AppFormActions from "./AppFormActions";
import BaseCom from "./common/BaseCom";
import DataTable from "./common/DataTable";
import Icon from "./common/Icon";
import { withParamsAndNavigate } from "./common/WithParamsAndNavigate";
import { NavMenuGlobal } from "./NavMenu";
import L from "./common/Lang";
import FormInput from "./common/FormInput";
import { Pop } from "./common/PopModal";
import Globals from "../shared/Globals";

class InstanceSetting extends BaseCom {
    constructor(props) {
        super(props);

        this.state = {
            info: {},
            syncList: []
        };
    }

    async componentDidMount() {
        NavMenuGlobal.setPath('Edit Settings');
        await this.loadSyncList();
    }

    componentWillUnmount() {
        NavMenuGlobal.clearTitle();
    }

    loadSyncList = async () => {
        try {
            let j = await qreq.getAsync('/api/sync-credential/list?instanceID=' + this.props.params.id);
            if (j.list) {
                this.setState({ syncList: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    onChange = (v, doGen) => {
        var info = { ...this.state.info };
        this.setState({ info: info });
    }

    new = () => {
        this.setState({ showNew: true, info: { instanceID: this.props.params.id } });
    }

    change = (e) => {
        this.setState({
            info: { ...this.state.info }
        });
    };

    submitNew = async (e) => {
        e?.preventDefault();
        const info = { ...this.state.info };
        try {
            let j = await qreq.postAsync('/api/sync-credential/save', info);
            if (j.errorCode === 0) {
                this.success('Saved!');
                this.setState({ showNew: false, info: {} });
                this.loadSyncList();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    enable = async (info) => {
        Pop.showConfirm(<>Are you sure you want to enable <b>{info.name}</b>?</>, <>Enable</>, async () => {
            try {
                let j = await qreq.postAsync('/api/sync-credential/set-disabled/false', info);
                if (j.errorCode === 0) {
                    this.success('Enabled!');
                    this.loadSyncList();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    disable = async (info) => {
        Pop.showConfirm(<>Are you sure you want to disable <b>{info.name}</b>?</>, <>Disable</>, async () => {
            try {
                let j = await qreq.postAsync('/api/sync-credential/set-disabled/true', info);
                if (j.errorCode === 0) {
                    this.success('Disabled!');
                    this.loadSyncList();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    delete = async (info) => {
        Pop.showConfirm(<>Are you sure you want to delete <b>{info.name}</b>?</>, <>Delete</>, async () => {
            try {
                let j = await qreq.postAsync('/api/sync-credential/delete', info);
                if (j.errorCode === 0) {
                    this.success('Deleted!');
                    this.loadSyncList();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    render() {
        return <div className="container-fluid">
            <AppFormActions showBackButton>
                <button type="submit" className="btn btn-primary btn-lg" onClick={this.new}><Icon icon="faPlus" /> New</button>
            </AppFormActions>
            <h2>Sync List</h2>
            <DataTable columns={[
                { name: 'id', title: 'ID', width: '100px' },
                {
                    name: 'name', title: 'Name'
                },
                {
                    name: 'status',
                    title: 'Status',
                    valueFunc: row => row.isDisabled ? <span className="text-danger">Disabled</span> : <span className="text-success">Enabled</span>
                },
                {
                    name: 'createdDate',
                    title: 'Created',
                    valueFunc: row => Date.parse(row.createdDate) > Date.parse('2000-01-01') ? Globals.toMDYHMLocalDateStringOrDiff(row.createdDate) : 'N/A'
                },
                {
                    name: 'actions',
                    valueFunc: row => <div className="d-flex gap-1">
                        {row.isDisabled ? <button title="Enable" type="button" onClick={() => this.enable(row)} className="btn btn-success"><Icon icon="faPlugCircleCheck" /></button>
                            : <button title="Disabled" type="button" onClick={() => this.disable(row)} className="btn btn-danger"><Icon icon="faPlugCircleMinus" /></button>}
                        <button title="Delete" type="button" onClick={() => this.delete(row)} className="btn btn-danger"><Icon icon="faTrash" /></button>
                    </div>,
                    width: '100px'
                }
            ]} data={this.state.syncList} />

            {/* MODAL */}
            <Modal show={this.state.showNew} onHide={() => this.setState({ showNew: false })} size="xl">
                <Modal.Header>
                    <Modal.Title>
                        <L>Add Sync Credential</L>
                    </Modal.Title>
                </Modal.Header>
                <form onSubmit={this.submitNew}>
                    <Modal.Body>
                        <FormInput
                            model={this.state.info}
                            name="name"
                            label="Name"
                            type="text"
                            onChange={this.change}
                            required
                        />
                        <FormInput
                            model={this.state.info}
                            name="publicKey"
                            label="Public Key"
                            type="text"
                            onChange={this.change}
                            required
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="submit"
                            className="btn btn-success btn-lg"
                            onClick={this.submitNew}
                        >
                            <Icon icon="faSave" /> <L>Save</L>
                        </button>
                        <button type="button" className="btn btn-secondary btn-lg" onClick={() => this.setState({ showNew: false })}><Icon icon="faClose" /> <L>Close</L></button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div >;
    }
}

export default withParamsAndNavigate(InstanceSetting);